import { useQuery } from "@tanstack/react-query";

import { publicCommonClient } from "../api";
import commonClient from "../api/private/commonClient";
import { useNavigate } from "react-router";
import {
  CPCodebooksResult,
  CPCompanyBrandingQueryResult,
  CPCompanyInfoResult,
  TableResultCPCustomer,
} from "../api/models/unified";
import { getTableQueryKey } from "../helpers/tableHelpers";
import { CustomerTableQuery } from "./models";
import customersClient from "../api/private/customersClient";

export const GLOBAL_QUERY_STALE_TIME = 3600000; // 1 hour in ms

const companyBrandingKey = "companyBranding";
const companyCustomerInfoKey = "companyCustomerInfo";
const codebookKey = "codebooks";
const customersKey = "customers";

export const getCompanyBrandingKeyBuilder = (tenantCode: string) => [
  companyBrandingKey,
  tenantCode,
];

export const getCompanyCustomerInfoKeyBuilder = () => [companyCustomerInfoKey];

export const useCompanyBrandingQuery = (tenantCode?: string) => {
  useNavigate();

  return useQuery<CPCompanyBrandingQueryResult>({
    queryKey: getCompanyBrandingKeyBuilder(tenantCode ?? ""),
    queryFn: tenantCode
      ? () => publicCommonClient.getCompanyBranding(tenantCode)
      : undefined,
    staleTime: GLOBAL_QUERY_STALE_TIME,
    enabled: !!tenantCode,
    refetchOnWindowFocus: false,
  });
};

export const useGetCompanyCustomerInfoQuery = () => {
  return useQuery<CPCompanyInfoResult>({
    queryKey: getCompanyCustomerInfoKeyBuilder(),
    queryFn: () => commonClient.getCompanyAndCustomerInfo(),
    staleTime: GLOBAL_QUERY_STALE_TIME,
  });
};

export const useGetCodebooksQuery = () => {
  return useQuery<CPCodebooksResult>({
    queryKey: [codebookKey],
    queryFn: () => commonClient.getCodebooks(),
    staleTime: GLOBAL_QUERY_STALE_TIME,
  });
};

export const useGetCustomersQuery = (params: CustomerTableQuery) => {
  return useQuery<TableResultCPCustomer>({
    queryKey: getTableQueryKey(customersKey, params),
    queryFn: () => customersClient.getCustomers(params),
  });
};
